// extracted by mini-css-extract-plugin
module.exports = {"listItem":"Pets-module__listItem___yqH9x","list":"Pets-module__list___3PZZ5"};